import React from "react";
var __jsx = React.createElement;
import { UnstyledButton } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** NIHSS scored-choice grid; stores the selected score as a string. */
export function NihssChoiceField(_ref) {
  var _field$choices, _field$observation;
  var field = _ref.field,
    value = _ref.value,
    disabled = _ref.disabled,
    onChange = _ref.onChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var choices = Object.values((_field$choices = field.choices) !== null && _field$choices !== void 0 ? _field$choices : {});
  var current = String(value !== null && value !== void 0 ? value : "");
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-start justify-between gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-strong text-sds-base-default"
  }, t((_field$observation = field.observation) !== null && _field$observation !== void 0 ? _field$observation : "")), field.description ? /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-small text-sds-base-secondary"
  }, t(field.description)) : null), /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-small-strong text-sds-brand-default"
  }, current || t("select_score", {
    defaultValue: "Select score"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap gap-2"
  }, choices.map(function (choice) {
    var score = String(choice.score);
    var selected = current === score;
    return /*#__PURE__*/React.createElement(UnstyledButton, {
      key: score,
      type: "button",
      disabled: disabled,
      "data-testid": "nihss-".concat(field.id, "-").concat(score),
      onClick: function onClick() {
        trackEvent(ANALYTICS_EVENTS.NIHSS, {
          fieldId: field.id
        });
        onChange(selected ? "" : score);
      },
      className: "flex h-20 w-20 flex-col items-center justify-center gap-1 rounded-sds-200 border text-center transition-colors ".concat(selected ? "border-teal-400 bg-teal-400/10 dark:border-teal-300" : "border-sds-base-default hover:border-teal-400 dark:hover:border-teal-300")
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-style-body-strong text-sds-base-default"
    }, score), /*#__PURE__*/React.createElement("span", {
      className: "text-style-label-base text-sds-base-secondary"
    }, t(choice.choice)));
  })));
}